import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  imports: [],
  templateUrl: './confirm-modal.html',
  styleUrl: './confirm-modal.scss',
  host: {
    '(document:keydown.escape)': 'close.emit()',
  },
})
export class ConfirmModal {
  readonly message = input.required<string>();

  readonly confirm = output<void>();
  readonly cancel = output<void>();
  readonly close = output<void>();
}
